
import {WarehouseEum} from "../enum"

const currencyOption = [
    {id: 'CNY', text: 'CNY'},
    {id: 'USD', text: 'USD'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            placeholder: '仓库',
            active: true,
            multiple: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '类型',
    prop: 'type',
    components: [{
        name: 'gj-select',
        prop: 'type',
        propsData: {
            placeholder: '类型',
            options: WarehouseEum.typeOption
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '币种',
    prop: 'currency',
    components: [{
        name: 'gj-select',
        prop: 'currency',
        propsData: {
            placeholder: '币种',
            options: currencyOption
        },
        style: {
            width: '120px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}]
